import {useFeaturesState} from '../../Organisms/Features'
import {useHasSalesRoleAndCountryItaly, useRolesByCustomerId} from '../../Roles'

import {evaluateFeatureFlag} from './evaluationFeatureFlags'

export const useIsFeatureEnabledForCurrentCustomer = (
  customerId?: string,
  featureFlagName = 'OrderIntake'
) => {
  const {normalized} = useFeaturesState()
  const hasSalesRoleAndCountryItaly = useHasSalesRoleAndCountryItaly()

  const featureFlag = normalized[featureFlagName]
  const {data: rolesBySelectedCustomer} = useRolesByCustomerId(customerId)

  const isFeatureEnabledForCurrentCustomer = evaluateFeatureFlag(
    rolesBySelectedCustomer,
    featureFlag?.constraints ?? [],
    customerId ?? '',
    hasSalesRoleAndCountryItaly
  )
  return isFeatureEnabledForCurrentCustomer
}
